// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import store from './store'
import '@/styles/index.scss'
import '@/icons'
import './permission' // permission control
import VueTimeago from 'vue-timeago'
import router from './router'
import VideoPlayer from 'vue-video-player'
import scroll from 'vue-seamless-scroll'
// 语言包
import i18n from './i18n/i18n';
// m3u8视频打点
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('./myVideo.css')
// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Confirm from '@/common/Confirm'

Vue.use(ElementUI, VideoPlayer, scroll, VueQuillEditor, i18n, Confirm)
Vue.config.productionTip = false
Vue.prototype.bus = new Vue()
/* eslint-disable no-new */
// router.beforeEach((to, from, next) => {
//   store.commit('clearToken'); // 取消请求
// })

Vue.prototype.resetSetItem = function (key, newVal) {
  // 创建一个StorageEvent事件
  var newStorageEvent = document.createEvent('StorageEvent');
  const storage = {
      setItem: function (k, val) {
          localStorage.setItem(k, val);
          // 初始化创建的事件
          newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
          // 派发对象
          window.dispatchEvent(newStorageEvent)
      }
  }
  return storage.setItem(key, newVal);
}
//系统错误捕获
// const errorHandler = (error, vm)=>{
//   console.error('抛出全局异常');
//   console.error(vm);
//   console.error(error);
// }
 
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = (error)=> errorHandler(error,this);

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    ja: require('date-fns/locale/ja')
  }
})



// WEBPACK FOOTER //
// ./src/main.js